module.exports = __webpack_public_path__ + "static/media/Conditional Situation in Spanish.2d1246f0.jpg";